import { Divider, Grid } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { WSTabs } from "../../Components/Tabs/WSTabs";
import { PaidList } from "./PaidList";
import { PaymentList } from "./PaymentList";

export const PaymentTab: React.FC<any> = React.memo((props) => {
  const {
    control,
    formState: { errors }
  } = useForm<any>();

  const tabsData: any[] = [
    { label: "Payment", content: <PaymentList /> },
    { label: "Paid", content: <PaidList /> }
  ];

  return (
    <>
      {" "}
      <Grid item container spacing={2}>
        <Grid item sm={12} xs={12}>
          <Divider />
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <WSTabs
          id="adasd"
          control={control}
          name="tabs"
          sx={{ backgroundColor: "#fff" }}
          tabs={tabsData}
          justifyTabs="flex-start"
        />
      </Grid>
    </>
  );
});
